import { configureStore } from "@reduxjs/toolkit";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

import {
  prevPathnameMiddleware,
  removeMasksFromValueMiddleware,
  removeUndefinedFieldsMiddleware,
} from "./middlewares";
import { rootReducer } from "./rootReducer";

const { NODE_ENV, REACT_APP_PUBLIC_URL: basename } = process.env;

export const history = createBrowserHistory({
  basename,
});

export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: rootReducer(history),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      routerMiddleware(history),
      prevPathnameMiddleware,
      removeUndefinedFieldsMiddleware,
      removeMasksFromValueMiddleware
    ),
  devTools: NODE_ENV === "development",
});
